import { CSSProperties, HTMLAttributes, ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { theme } from 'coreOld/themes';

type Cols = 0.5 | 1 | 1.5 | 2 | 2.5 | 2.8 | 3 | 3.5 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 10.5 | 11 | 12;
type JustifyContent = 'flex-start' | 'center' | 'flex-end' | 'space-between';
type AlignItems = 'flex-start' | 'center' | 'flex-end';

const containerStyle = (container: boolean) => {
  if (!container) {
    return;
  }

  return `
    display: flex;
    flex-wrap: wrap;
    width:100%;
  `;
};

const itemStyle = (item: boolean) => {
  if (!item) {
    return;
  }

  return `
    display: block;
  `;
};

const colStyle = (col: Cols) => {
  if (!col) {
    return;
  }

  return `
   flex-basis: ${(col / 12) * 100}%;
  `;
};

const spacingStyle = (spacing: number) => {
  if (!spacing) {
    return;
  }

  return `
   margin: -${theme.spacing * spacing}px;

   > div {
    padding: ${theme.spacing * spacing}px;
  }
  `;
};

type WrapperProps = {
  xs?: Cols;
  sm?: Cols;
  md?: Cols;
  lg?: Cols;
  spacing?: number;
  item?: boolean;
  container?: boolean;
  justifyContent?: JustifyContent;
  alignItems?: AlignItems;
  style?: CSSProperties;
  children?: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

const Wrapper = styled.div<WrapperProps>`
  ${({ xs, sm, md, lg, spacing, item, container, justifyContent, alignItems, style }) => {
    return css`
      justify-content: ${justifyContent};
      align-items: ${alignItems};

      ${containerStyle(container)}
      ${itemStyle(item)};
      ${spacingStyle(spacing)};

      @media only screen and (min-width: ${theme.breakpoints.xs}) {
        ${colStyle(xs)};
      }

      @media only screen and (min-width: ${theme.breakpoints.sm}) {
        ${colStyle(sm)};
      }

      @media only screen and (min-width: ${theme.breakpoints.md}) {
        ${colStyle(md)};
      }

      @media only screen and (min-width: ${theme.breakpoints.lg}) {
        ${colStyle(lg)};
      }

      ${style ? css(style as any) : ''}
    `;
  }};
`;

interface IProps {
  children: ReactNode;
  container?: boolean;
  item?: boolean;
  xs?: Cols;
  sm?: Cols;
  md?: Cols;
  lg?: Cols;
  spacing?: number;
  justifyContent?: JustifyContent;
  alignItems?: AlignItems;
  style?: CSSProperties;
}

const Grid = ({
  children,
  container,
  item,
  xs,
  sm = xs,
  md = sm,
  lg = md,
  spacing,
  justifyContent,
  alignItems,
  ...props
}: IProps & HTMLAttributes<HTMLDivElement>) => {
  return (
    <Wrapper
      {...{
        children,
        container,
        item,
        xs,
        sm,
        md,
        lg,
        spacing,
        justifyContent,
        alignItems,
        ...props,
      }}
    >
      {children}
    </Wrapper>
  );
};

export default Grid;
